import { useMemo } from "react";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import LatestGrid from "@/pages/home/components/LatestGrid";
import EditorPicks from "@/pages/home/components/EditorPicks";
import LatestReviews, { type ReviewItem } from "@/pages/home/components/LatestReviews";
import SiteIntro from "@/pages/home/components/SiteIntro";
import { works, editorPicks } from "@/data/catalog";
import { getFeatured, getLatest } from "@/utils/workUtils";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

export default function Home() {
  useDocumentMeta({
    title: "韩国伦理 - 最新韩国伦理电影电视剧专题平台",
    description:
      "韩国伦理网站提供丰富的韩国伦理电影和电视剧内容，涵盖剧情介绍、影评和专题推荐，助您深入了解韩国伦理影视作品。",
    keywords: "韩国伦理,韩国伦理电影,韩国伦理电视剧,韩国伦理影视,韩国伦理剧情",
  });

  const featured = useMemo(() => getFeatured(works, 5), []);
  const latestMovies = useMemo(() => getLatest(works, "movie", 4), []);
  const latestDramas = useMemo(() => getLatest(works, "drama", 4), []);

  const reviews = useMemo<ReviewItem[]>(() => {
    const list: ReviewItem[] = [];
    works.forEach((work) => {
      work.reviews.forEach((review) => {
        list.push({
          workId: work.id,
          workTitle: work.title,
          genre: work.genres[0],
          author: review.author,
          date: review.date,
          content: review.content,
        });
      });
    });
    return list.sort((a, b) => (a.date < b.date ? 1 : -1)).slice(0, 6);
  }, []);

  const reviewCount = useMemo(
    () => works.reduce((sum, work) => sum + work.reviews.length, 0),
    [],
  );

  return (
    <div className="flex flex-col">
      <HeroCarousel slides={featured} />

      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14 flex flex-col gap-12 md:gap-16">
        <LatestGrid
          title="最新伦理电影"
          subtitle="近期更新的韩国伦理电影，含剧情简介与影评"
          moreLink="/category/erotic"
          works={latestMovies}
          emptyText="暂无伦理电影内容"
        />

        <LatestGrid
          title="最新伦理电视剧"
          subtitle="连续剧集形式的伦理题材电视剧，适合沉浸式追看"
          moreLink="/category/drama"
          works={latestDramas}
          emptyText="暂无伦理电视剧内容"
        />

        <EditorPicks picks={editorPicks} />

        <LatestReviews items={reviews} />

        <SiteIntro workCount={works.length} reviewCount={reviewCount} pickCount={editorPicks.length} />
      </div>
    </div>
  );
}